import axiosInstance from '@/services';

export const magnoliaAPI = {
  /**
   * API service to get Magnolia content response
   * @param apiEndpoint string
   * @param params map of string
   * @returns Magnolia content response
   */
  getContent: async (apiEndpoint: string, params?: {}) => {
    const response = await axiosInstance.get(apiEndpoint, params);
    return response;
  },
};
